import {useState, useEffect} from 'react';
import {useAppSelector} from '../store/hooks';
import {getUserPermissions} from '../api/general';

const usePermissions = () => {
  const {activeTenant} = useAppSelector(({permissions}) => permissions);
  const [isLoading, setLoading] = useState(false);
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState<any>(null);

  useEffect(() => {
    const getResponse = async () => {
      setLoading(true);
      try {
        const response = await getUserPermissions();
        setData(response);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    if (activeTenant !== data?.activeTenant) {
      getResponse();
    }
  }, [activeTenant]);

  return [data, isLoading, error];
};

export default usePermissions;

